import store from '../../../core/store';

export const listCompanyPositions = () => {
  return store.dispatch({
    action: 'table.company_positions/LIST_COMPANY_POSITIONS',
    method: 'GET',
    endpoint: '/company_positions',
    main: true,
  });
};

export const createCompanyPosition = (formData) => {
  return store.dispatch({
    action: 'table.company_positions/CREATE_COMPANY_POSITIONS',
    method: 'POST',
    endpoint: '/company_positions',
    data: formData,
  });
};

export const readCompanyPosition = (company_position_id) => {
  return store.dispatch({
    action: 'table.company_positions/READ_COMPANY_POSITION',
    method: 'GET',
    endpoint: '/company_positions/' + company_position_id,
  });
};

export const updateCompanyPosition = (company_position_id, formData) => {
  return store.dispatch({
    action: 'table.company_positions/UPDATE_COMPANY_POSITIONs',
    method: 'PUT',
    endpoint: '/company_positions/' + company_position_id,
    data: formData,
  });
};

export const deleteCompanyPosition = (id) => {
  return store.dispatch({
    action: 'table.company_positions/DELETE_COMPANY_POSITIONS',
    method: 'DELETE',
    endpoint: '/company_positions/' + id,
  });
};
